<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title class="mb-3 text-h5 font-weight-bold">
        {{ wordList.lbl_delivery_cap_list }}
      </v-card-title>
    </v-card>
    <!-- 表示日数 -->
    <v-card-text class="pt-2 mt-2">
      <v-card flat>
        <v-row class="align-center py-2">
          <v-col cols="auto" class="py-0 d-flex align-center">
            <p class="mx-2 mb-0 font-weight-bold">
              {{ wordList.lbl_display_date }}
            </p>
          </v-col>
          <v-col cols="12" sm="2" class="py-0 pr-0 d-flex align-center">
            <v-menu
              :close-on-content-click="false"
              :offset="[40, 0]"
              transition="scale-transition"
              location="bottom"
              min-width="auto"
            >
              <template #activator="{ props }">
                <Field v-slot="{ errors }" :name="fieldName('lbl_recript_date_from')" rules="max:10">
                  <v-text-field
                    v-model="displayDateFrom"
                    :label="wordList.lbl_recript_date_from"
                    readonly
                    variant="outlined"
                    density="compact"
                    clearable
                    class="mt-2"
                    v-bind="props"
                    :error-messages="errors"
                    :disabled="processFlag != 0"
                    bg-color="#fff"
                  ></v-text-field>
                </Field>
              </template>
              <v-locale-provider locale="ja" :messages="{ ja: vuetifyJa }">
                <v-date-picker
                  v-datepicker-scroll
                  v-model="displayDateFrom"
                  hide-header
                  show-adjacent-months
                  view-mode="month"
                  @update:model-value="onSelectDisplayDateFrom"
                ></v-date-picker>
              </v-locale-provider>
            </v-menu>
          </v-col>
          <v-col cols="auto" class="py-0 d-flex align-center">
            <p class="mx-2 mb-0">〜</p>
          </v-col>
          <v-col cols="12" sm="2" class="py-0 pr-0 d-flex align-center">
            <v-menu
              :close-on-content-click="false"
              :offset="[40, 0]"
              transition="scale-transition"
              location="bottom"
              min-width="auto"
            >
              <template #activator="{ props }">
                <Field v-slot="{ errors }" :name="fieldName('lbl_recript_date_to')" rules="max:10">
                  <v-text-field
                    v-model="displayDateTo"
                    :label="wordList.lbl_recript_date_to"
                    readonly
                    variant="outlined"
                    density="compact"
                    clearable
                    class="mt-2"
                    v-bind="props"
                    :error-messages="errors"
                    :disabled="processFlag != 0"
                    bg-color="#fff"
                  ></v-text-field>
                </Field>
              </template>
              <v-locale-provider locale="ja" :messages="{ ja: vuetifyJa }">
                <v-date-picker
                  v-datepicker-scroll
                  v-model="displayDateTo"
                  hide-header
                  show-adjacent-months
                  view-mode="month"
                  @update:model-value="onSelectDisplayDateTo"
                ></v-date-picker>
              </v-locale-provider>
            </v-menu>
          </v-col>
        </v-row>
      </v-card>
    </v-card-text>
    <v-tabs v-model="model" hide-slider>
      <div class="tab_switch d-flex align-center">
        <v-tab
          :value="0"
          :class="[model === 0 ? 'tab_switch_active' : 'tab_switch_inactive', 'd-flex align-center justify-center rounded-pill']"
          :disabled="processFlag != 0"
          @click="onClickShopTab"
        >
          {{ wordList.lbl_shop_cap_setting }}
        </v-tab>
        <v-tab
          :value="1"
          :class="[model === 1 ? 'tab_switch_active' : 'tab_switch_inactive', 'ml-2 d-flex align-center justify-center rounded-pill']"
          :disabled="processFlag != 0"
          @click="onClickGroupTab"
        >
          {{ wordList.lbl_delivery_group_cap_setting }}
        </v-tab>
      </div>
    </v-tabs>
    <!-- 店舗キャップ設定タブ { -->
    <v-tabs-window v-model="model">
        <v-tabs-window-item :value="0">
          <v-card flat>
            <form>
              <v-card flat class="mt-5">
                <v-expansion-panels v-model="panel" flat multiple class="br_1">
                  <v-expansion-panel>
                    <v-expansion-panel-title class="d-none"></v-expansion-panel-title>
                    <v-expansion-panel-text class="bk_gray_3">
                      <v-card-text>
                        <v-row class="pt-4">
                        <!-- チェーン名 -->
                        <v-col v-if="chainViewFlag" sm="6" md="4" class="py-0">
                          <v-autocomplete
                            v-model="chainSelectValues"
                            density="compact"
                            :items="chainListItems"
                            item-title="name"
                            item-value="chain_code"
                            :label="wordList.lbl_chain_name"
                            :placeholder="wordList.plc_selectbox"
                            :no-data-text="wordList.lbl_no_data_text"
                            bg-color="white"
                            :disabled="processFlag != 0"
                            return-object
                            variant="outlined"
                            @update:model-value="onChangeChain"
                          ></v-autocomplete>
                        </v-col>
                        <!-- 店舗名 -->
                        <v-col sm="6" md="4" class="py-0">
                          <v-autocomplete
                            v-model="shopSelectValues"
                            density="compact"
                            :items="shopListItems"
                            item-title="name"
                            item-value="shop_code"
                            :label="wordList.lbl_shop_name"
                            :placeholder="wordList.plc_selectbox"
                            :no-data-text="wordList.lbl_no_data_text"
                            bg-color="white"
                            :disabled="processFlag != 0"
                            return-object
                            variant="outlined"
                            @update:model-value="onChangeShop"
                          ></v-autocomplete>
                        </v-col>
                        <!-- エリア名 -->
                        <v-col sm="6" md="4" class="py-0">
                          <v-autocomplete
                            v-model="areaSelectValues"
                            density="compact"
                            :items="areaListItems"
                            item-title="area_name"
                            item-value="area_code"
                            :label="wordList.lbl_area_name"
                            :placeholder="wordList.plc_selectbox"
                            :no-data-text="wordList.lbl_no_data_text"
                            bg-color="white"
                            :disabled="
                              shopSelectValues === null || processFlag != 0
                            "
                            return-object
                            variant="outlined"
                            @update:model-value="onChangeArea"
                          ></v-autocomplete>
                        </v-col>
                        </v-row>
                      </v-card-text>
                      <v-col class="text-red">
                        {{ wordList.lbl_shop_select }}
                        {{ wordList.lbl_area_select }}
                        {{ wordList.lbl_next_delivery_cap_regist }}
                      </v-col>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </form>
            <v-row
              v-if="processFlag == 0"
              class="justify-end mt-5"
              style="width: 100%; overflow: visible;"
              no-gutters
            >
              <v-btn
                color="primary"
                class="mb-2 px-10 py-2"
                :disabled="!shopSelectValues?.shop_code?.length"
                @click="onClickEdit"
              >
                {{ wordList.btn_delivery_cap_edit }}
              </v-btn>
            </v-row>
            <v-row
              v-if="processFlag == 1"
              class="justify-end mt-5"
              style="width: 100%; overflow: visible;"
              no-gutters
            >
              <v-btn
                color="primary"
                class="mb-2 px-4 py-2"
                style="margin-right: 20px"
                @click="onClickEditConfirm"
              >
                {{ wordList.btn_update }}
              </v-btn>
              <v-btn
                color="error"
                variant="outlined"
                class="mb-2 px-4 py-2"
                @click="onClickCancel"
              >
                {{ wordList.btn_cancel }}
              </v-btn>
            </v-row>
            <div
              v-for="[key, value] in Array.from(mappedListData)"
              :key="key"
              :value="value"
            >
              <span
                v-if="selectShopFlg || selectAreaFlg"
                class="catch_area pt-5"
                >{{ getAreaName(key) }}
                <span
                  v-if="areaParentData.get(key) > 0"
                  style="margin-left: 10px"
                  >[<a class="text-primary text-decoration-none cursor-pointer" @click="confirmAreaGroup(key)">グループ確認</a>]</span
                ></span
              >
              <v-data-table
                v-if="selectShopFlg || selectAreaFlg"
                :items="value"
                :headers="tableHeaders"
                :items-per-page="value.length"
                :no-data-text="wordList.lbl_no_data_text"
                hide-default-footer
                :cell-props="capCellProps"
              >
                <template
                  v-for="(header_item, index) in tableHeaders"
                  :key="index"
                  #[`item.${header_item.key}`]="props"
                >
                  <div
                    v-if="header_item.key === 'delivery_id_time'"
                    class="text-center d-flex justify-center px-0"
                  >
                    <div class="d-flex flex-column align-center justify-center text-center my-4">
                      <span
                        v-if="props.item.has_parent_group > 0"
                        class="cap_font"
                      >
                        <a
                          class="text-primary text-decoration-none font-weight-bold cursor-pointer"
                          @click="
                            confirmDeliveryGroup({
                              area_code: key,
                              delivery_id: props.item.delivery_id,
                            })
                          "
                        >
                          {{
                            props.item.delivery_id == 0
                              ? "都度配達"
                              : props.item.delivery_id + "便"
                          }}<br />
                          {{ props.item.delivery_time }}
                        </a>
                      </span>
                      <span v-else class="cap_font">
                        {{
                          props.item.delivery_id == 0
                            ? "都度配達"
                            : props.item.delivery_id + "便"
                        }}<br />
                        {{ props.item.delivery_time }}
                      </span>
                    </div>
                  </div>
                  <div
                    v-else
                    class="cap-cell-content text-center d-flex justify-center px-0"
                  >
                    <div
                      class="d-flex"
                      style="min-width: 150px;"
                    >
                      <div
                        style="white-space: pre; min-width: 56px; width: 56px; max-height: 48px"
                      >
                        <span class="cap_title">受注件数</span><br />
                        <span class="cap_font">
                          {{ props.item[header_item.key].receipt_count }}
                        </span>
                      </div>
                      <div
                        style="
                          white-space: pre;
                          max-width: 5px;
                          min-height: 48px;
                          padding: 12px 0;
                          margin: 0 10px;
                        "
                      >
                        /
                      </div>
                      <div
                        style="white-space: pre; min-width: 56px; width: 56px; max-height: 48px"
                      >
                        <span class="cap_title">キャップ数</span><br />
                        <span v-if="processFlag == 0" class="cap_font">
                          {{ props.item[header_item.key].cap_count }}
                        </span>
                        <span v-if="processFlag == 1">
                          <Field
                            v-slot="{ errors }"
                            name="キャップ数"
                            rules="numeric|max:11"
                          >
                            <v-text-field
                              v-model.number="
                                props.item[header_item.key].cap_count
                              "
                              variant="outlined"
                              class="compact-form text-right"
                              :error-messages="errors"
                              bg-color="#fff"
                            ></v-text-field>
                          </Field>
                        </span>
                      </div>
                    </div>
                  </div>
                </template>
              </v-data-table>
            </div>
          </v-card>
          <AlertDialog
            v-model="errdialog"
            :title="wordList.lbl_err_dialog_title"
            :message="errMessage"
            type="error"
          />
          <AlertDialog
            v-model="validErrdialog"
            title="入力エラー"
            :message="capMessage"
            type="error"
          />
          <!-- { グループ確認ダイアログ -->
          <v-dialog
            v-model="groupConfirmDialog"
            width="450"
            @keydown.enter="groupConfirmDialog = false"
          >
            <v-card align="center">
              <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
                グループ確認
              </v-card-title>
              <v-card-text>
                <table class="font-weight-bold">
                  <tbody>
                    <tr>
                      <td align="right">店舗:</td>
                      <td>
                        {{ parentGroupItems.parent_group_response.shop_name }}
                      </td>
                    </tr>
                    <tr>
                      <td align="right">エリア:</td>
                      <td>
                        {{ parentGroupItems.parent_group_response.area_name }}
                      </td>
                    </tr>
                    <template
                      v-for="(parent_group_list, index) in parentGroupItems
                        .parent_group_response.parent_group_list"
                      :key="index"
                    >
                      <tr>
                        <td align="right">
                          {{ parent_group_list.delivery_id }}便:
                        </td>
                        <td>
                        {{ parent_group_list.group_name }}(<a
                          class="text-primary text-decoration-none cursor-pointer"
                          @click="toGroupCap(parent_group_list.group_code)"
                          >グループキャップへ</a
                        >)
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- } グループ確認ダイアログ -->

          <!-- { 更新確認ダイアログ -->
          <v-dialog
            v-model="confirmDialog"
            persistent
            width="450"
            @keydown.enter="confirmDialog = false"
          >
            <v-card align="center">
              <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
                更新確認
              </v-card-title>
              <v-card-text>
                キャップ数の設定を更新します。<br />よろしいですか？
              </v-card-text>
              <v-card-actions class="justify-center pb-4">
                <v-btn
                  color="primary"
                  variant="flat"
                  class="px-8 mx-2"
                  @click="onClickEditOK"
                >
                  {{ wordList.btn_update }}
                </v-btn>
                <v-btn
                  variant="outlined"
                  color="error"
                  class="px-8 mx-2"
                  @click="confirmDialog = false"
                >
                  {{ wordList.btn_cancel }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- } 更新確認ダイアログ -->

          <!-- { 更新完了ダイアログ -->
          <v-dialog
            v-model="completeDialog"
            persistent
            width="450"
            @keydown.enter="completeDialog = false"
          >
            <v-card align="center">
              <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
                更新完了
              </v-card-title>
              <v-card-text> キャップ数の更新が完了しました。 </v-card-text>
              <v-card-actions class="justify-center pb-4">
                <v-btn
                  color="primary"
                  class="px-8"
                  variant="outlined"
                  @click="completeDialog = false"
                >
                  閉じる
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- } 更新完了ダイアログ -->
          <v-overlay
            :model-value="overlay"
            class="d-flex align-center justify-center"
          >
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-tabs-window-item>
      <!-- } 店舗キャップ設定タブ -->
      <!-- グループキャップ設定タブ { -->
        <v-tabs-window-item :value="1">
          <v-card flat>
            <form>
              <v-card flat class="mt-5">
                <v-expansion-panels v-model="panel" flat multiple class="br_1">
                  <v-expansion-panel>
                    <v-expansion-panel-title class="d-none"></v-expansion-panel-title>
                    <v-expansion-panel-text class="bk_gray_3">
                      <v-card-text>
                        <v-row class="pt-4">
                        <!-- チェーン名 -->
                        <v-col v-if="chainViewFlag" sm="6" md="4" class="py-0">
                          <v-autocomplete
                            v-model="chainSelectValues"
                            density="compact"
                            :items="chainListItems"
                            item-title="name"
                            item-value="chain_code"
                            :label="wordList.lbl_chain_name"
                            :placeholder="wordList.plc_selectbox"
                            :no-data-text="wordList.lbl_no_data_text"
                            bg-color="white"
                            :disabled="processFlag != 0"
                            return-object
                            variant="outlined"
                            @update:model-value="onChangeChain"
                          ></v-autocomplete>
                        </v-col>
                        <!-- グループ名 -->
                        <v-col sm="6" md="4" class="py-0">
                          <v-autocomplete
                            v-model="deliveryGroupSelectValues"
                            density="compact"
                            :items="deliveryGroupListItems"
                            item-title="name"
                            item-value="group_code"
                            :label="wordList.lbl_delivery_group_name"
                            :placeholder="wordList.plc_selectbox"
                            :no-data-text="wordList.lbl_no_data_text"
                            bg-color="white"
                            :disabled="processFlag != 0"
                            return-object
                            variant="outlined"
                            @update:model-value="onChangeDeliveryGroup"
                          ></v-autocomplete>
                        </v-col>
                        <!-- グループ便 -->
                        <v-col sm="6" md="4" class="py-0">
                          <v-autocomplete
                            v-model="deliveryGroupIdSelectValues"
                            density="compact"
                            :items="deliveryGroupItems"
                            item-title="group_delivery_id_name"
                            item-value="group_delivery_id"
                            :label="wordList.lbl_delivery_group_id_name"
                            :placeholder="wordList.plc_selectbox"
                            :no-data-text="wordList.lbl_no_data_text"
                            bg-color="white"
                            :disabled="
                              deliveryGroupSelectValues === null ||
                              processFlag != 0
                            "
                            return-object
                            variant="outlined"
                            multiple
                            @update:model-value="onChangeDeliveryGroupId"
                          ></v-autocomplete>
                        </v-col>
                        </v-row>
                      </v-card-text>
                    </v-expansion-panel-text>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </form>

            <!-- 検索条件入力 } -->
            <v-row
              v-if="processFlag == 0"
              class="justify-end mt-5"
              style="width: 100%; overflow: visible;"
              no-gutters
            >
              <v-btn
                color="primary"
                class="mb-2 px-10 py-2"
                :disabled="!deliveryGroupSelectValues?.group_code?.length"
                @click="onClickEdit"
              >
                {{ wordList.btn_delivery_group_cap_edit }}
              </v-btn>
            </v-row>
            <v-row
              v-if="processFlag == 1"
              class="justify-end mt-5"
              style="width: 100%; overflow: visible;"
              no-gutters
            >
              <v-btn
                color="primary"
                class="mb-2 px-4 py-2"
                style="margin-right: 20px"
                @click="onClickEditConfirm"
              >
                {{ wordList.btn_update }}
              </v-btn>
              <v-btn
                color="error"
                variant="outlined"
                class="mb-2 px-4 py-2"
                @click="onClickCancel"
              >
                {{ wordList.btn_cancel }}
              </v-btn>
            </v-row>

            <div
              v-for="[key, value] in Array.from(mappedListGroupData)"
              :key="key"
              :value="value"
            >
              <span v-if="selectGroupFlg" class="catch_group pt-5"
                >グループ便 {{ key == 0 ? "都度" : key }}便
              </span>
              <v-data-table
                v-if="selectGroupFlg || selectGroupIdFlg"
                :items="value"
                :headers="tableHeaders"
                :items-per-page="value.length"
                :no-data-text="wordList.lbl_no_data_text"
                hide-default-footer
                class="cap-group-table"
                :cell-props="capCellProps"
              >
                <template
                  v-for="(header_item, index) in tableHeaders"
                  :key="index"
                  #[`item.${header_item.key}`]="props"
                >
                  <div
                    v-if="
                      header_item.key === 'delivery_id_time' &&
                      props.item.group_flag
                    "
                    class="text-center d-flex justify-center py-0 px-0"
                  >
                    <div class="d-flex flex-column align-center justify-center text-center">
                      <span class="cap_font">
                        {{
                          props.item.group_delivery_id == 0
                            ? "都度便"
                            : props.item.group_delivery_id + "便"
                        }}
                      </span>
                    </div>
                  </div>
                  <div
                    v-else-if="
                      header_item.key === 'delivery_id_time' &&
                      props.item.area_flag
                    "
                    class="text-center d-flex justify-center py-0 px-0"
                  >
                    <div class="d-flex flex-column align-center justify-center text-center">
                      <span class="cap_font_s">
                        <a class="text-primary text-decoration-none font-weight-bold d-inline-flex flex-column align-center justify-center cursor-pointer" @click="confirmDeliveryTime(props.item)">
                          {{ props.item.shop_name }}<br />
                          {{ props.item.area_name }}
                          {{
                            props.item.delivery_id == 0
                              ? "都度便"
                              : props.item.delivery_id + "便"
                          }}<br />
                          {{ props.item.delivery_time }}
                        </a>
                      </span>
                    </div>
                  </div>
                  <div
                    v-else-if="
                      header_item.key === 'delivery_id_time' &&
                      !props.item.group_flag &&
                      !props.item.area_flag
                    "
                    class="blank-line-content px-0"
                  ></div>
                  <div
                    v-else-if="props.item.group_flag || props.item.area_flag"
                    class="cap-cell-content text-center d-flex justify-center py-2 px-0"
                  >
                    <div class="d-flex flex-column align-center my-1">
                      <div class="d-flex my-1" style="min-width: 150px;">
                        <div
                          style="white-space: pre; min-width: 56px; width: 56px; max-height: 48px"
                        >
                          <span class="cap_title">受注件数</span><br />
                          <span class="cap_font">
                            <span v-if="props.item.group_flag">
                              {{ props.item[header_item.key].group_orders }}
                            </span>
                            <span v-else>
                              {{ props.item[header_item.key].orders }}
                            </span>
                          </span>
                        </div>
                        <div
                          style="
                            white-space: pre;
                            max-width: 5px;
                            min-height: 48px;
                            padding: 12px 0;
                            margin: 0 10px;
                          "
                        >
                          /
                        </div>
                        <div
                          style="white-space: pre; min-width: 56px; width: 56px; max-height: 48px"
                        >
                          <span v-if="props.item.group_flag" class="cap_title"
                            >キャップ数</span
                          >
                          <span v-else class="cap_title">最低保証</span><br />
                          <span v-if="processFlag == 0" class="cap_font">
                            <span v-if="props.item.group_flag">
                              {{ props.item[header_item.key].group_cap }}
                            </span>
                            <span v-else>
                              {{ props.item[header_item.key].cap }}
                            </span>
                          </span>
                          <span v-if="processFlag == 1">
                            <span v-if="props.item.group_flag">
                              <Field
                                v-slot="{ errors }"
                                name="グループキャップ数"
                                rules="numeric|max:11"
                              >
                                <v-text-field
                                  v-model.number="
                                    props.item[header_item.key].group_cap
                                  "
                                  variant="outlined"
                                  class="compact-form text-right"
                                  :error-messages="errors"
                                  bg-color="#fff"
                                ></v-text-field>
                              </Field>
                            </span>
                            <span v-else>
                              <Field
                                v-slot="{ errors }"
                                name="最低保証数"
                                rules="numeric|max:11"
                              >
                                <v-text-field
                                  v-model.number="props.item[header_item.key].cap"
                                  variant="outlined"
                                  class="compact-form text-right"
                                  :error-messages="errors"
                                  bg-color="#fff"
                                ></v-text-field>
                              </Field>
                            </span>
                          </span>
                        </div>
                      </div>
                      <div v-if="props.item.group_flag" class="my-1">
                        <span class="catch_line"></span>
                        <span class="cap_title">残り自由分配数 : </span
                        ><span class="cap_font" style="font-weight: bold">{{
                          props.item[header_item.key].group_dist_cap
                        }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </v-data-table>
            </div>
          </v-card>
          <!-- { 店舗・配達情報ダイアログ -->
          <v-dialog
            v-model="deliveryTimeConfirmDialog"
            width="450"
            @keydown.enter="deliveryTimeConfirmDialog = false"
          >
            <v-card align="center">
              <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
                店舗・配達情報
              </v-card-title>
              <v-card-text>
                <table class="font-weight-bold">
                  <tbody>
                    <tr>
                      <td align="right">店舗:</td>
                      <td>
                        {{ deliveryTimeConfirm.shop_name }}
                      </td>
                    </tr>
                    <tr>
                      <td align="right">エリア:</td>
                      <td>
                        {{ deliveryTimeConfirm.area_name }}
                      </td>
                    </tr>
                    <tr>
                      <td align="right">便:</td>
                      <td>
                        {{
                          deliveryTimeConfirm.delivery_id == 0
                            ? "都度便"
                            : deliveryTimeConfirm.delivery_id + "便"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td align="right">配達時間:</td>
                      <td>
                        {{ deliveryTimeConfirm.delivery_time }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <v-btn color="primary" class="mb-2 px-4" @click="toShopCap()">
                  {{ wordList.btn_to_shop_cap }}
                </v-btn>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- } グ店舗・配達情報ダイアログ -->
          <v-overlay
            :model-value="overlay"
            class="d-flex align-center justify-center"
          >
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
        </v-tabs-window-item>
    </v-tabs-window>
  </v-container>
</template>

<script setup lang="ts">
import { ref, reactive, onMounted } from "vue";
import { Field, defineRule, configure } from "vee-validate";
import { localize } from "@vee-validate/i18n";
import { required, max } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import { ja as vuetifyJa } from "vuetify/locale";
import AlertDialog from "@/components/AlertDialog.vue";
import {
  type ShopListInput,
  type DeliveryGroupListInput,
  type DeliveryGroupGetInput,
  type DeliveryCapOrdersListInput,
  type DeliveryGroupCapOrdersListInput,
} from "@/generated/graphql";
import { localStorageGetCustomerCode } from "@/common/localStorageUtil";

import { useDeliveryCapSettingUiState } from "./composables/useDeliveryCapSettingUiState";
import { useDeliveryCapSettingInit } from "./composables/useDeliveryCapSettingInit";
import { useDeliveryCapSettingTable } from "./composables/useDeliveryCapSettingTable";
import { useDeliveryCapSettingFilter } from "./composables/useDeliveryCapSettingFilter";
import { useDeliveryCapSettingActions } from "./composables/useDeliveryCapSettingActions";
import { useDeliveryCapSettingDialog } from "./composables/useDeliveryCapSettingDialog";
import type {
  ChainItem,
  ChainSelectValue,
  ShopItem,
  ShopSelectValue,
  AreaListItem,
  DeliveryGroupSelectValue,
  DeliveryGroupIdItem,
  TableHeaderItem,
  ListData,
  ListGroupData,
} from "./types";

defineRule("required", required);
defineRule("max", max);
configure({
  generateMessage: localize({ ja }),
});

// ---- UI状態 ----
const {
  errdialog,
  errMessage,
  validErrdialog,
  capMessage,
  overlay,
  processFlag,
  mode,
  model,
  panel,
  confirmDialog,
  completeDialog,
  groupConfirmDialog,
  deliveryTimeConfirmDialog,
  selectShopFlg,
  selectAreaFlg,
  selectGroupFlg,
  selectGroupIdFlg,
  setIdFlg,
} = useDeliveryCapSettingUiState();

// ---- 共有 refs（循環依存回避のため index.vue で一元生成） ----

// フィルター選択値
const chainListItems = ref<ChainItem[]>([]);
const chainSelectValues = ref<ChainSelectValue>({ chain_code: "", name: "" });
const shopListItems = ref<ShopItem[]>([]);
const shopSelectValues = ref<ShopSelectValue>({ shop_code: "", name: "" });
const areaListItems = ref<(AreaListItem | null)[]>([]);
const areaSelectValues = ref<AreaListItem | null>(null);
const deliveryGroupSelectValues = ref<DeliveryGroupSelectValue>({ group_code: "", name: "" });
const deliveryGroupIdSelectValues = ref<DeliveryGroupIdItem[]>([]);

// 店舗一覧 input
const shopListInput = reactive<ShopListInput>({
  chain_code: "",
  customer_code: localStorageGetCustomerCode(),
  limit: 10000,
  offset: 0,
});

// 配達グループ一覧 input
const deliveryGroupListInput = reactive<DeliveryGroupListInput>({
  chain_code: "",
  customer_code: localStorageGetCustomerCode(),
});

// 配達グループ便一覧 input
const deliveryGroupGetInput = reactive<DeliveryGroupGetInput>({
  chain_code: "",
  customer_code: localStorageGetCustomerCode(),
  group_code: "",
});

// テーブル・日付
const now = new Date();
const nowDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
const tableHeaders = ref<TableHeaderItem[]>([]);
const displayDateFrom = ref<string | null>(nowDate);
const displayDateTo = ref<string | null>(nowDate);
const listDataArray = ref<ListData[]>([]);
const listGroupDataArray = ref<ListGroupData[]>([]);

// エリア便キャップ一覧取得 input
const deliveryCapOrdersListInput = reactive<DeliveryCapOrdersListInput>({
  customer_code: localStorageGetCustomerCode(),
  chain_code: "",
  shop_code: "",
  area_code: "",
  display_date_start: "",
  display_date_end: "",
});

// グループ便キャップ一覧取得 input
const deliveryGroupCapOrdersListInput = reactive<DeliveryGroupCapOrdersListInput>({
  customer_code: localStorageGetCustomerCode(),
  chain_code: "",
  group_code: "",
  display_date_start: "",
  display_date_end: "",
});

const areaParentData = reactive<Map<string, number>>(new Map());
const mappedListData = reactive<Map<string, ListData[]>>(new Map());
const mappedListGroupData = reactive<Map<string, ListGroupData[]>>(new Map());

// ---- 初期化（wordList / chainViewFlag を先に取得） ----
const { wordList, chainViewFlag, runInitialLoad } = useDeliveryCapSettingInit({
  errdialog,
  errMessage,
  chainListItems,
  chainSelectValues,
  shopListItems,
  shopSelectValues,
  areaListItems,
  shopListInput,
});

// ---- テーブル（共有 refs を受け取り、関数のみ返す） ----
const {
  getCapOrders,
  getGroupCapOrders,
  onChangeDate,
  onSelectDisplayDateFrom,
  onSelectDisplayDateTo,
  capCellProps,
  fieldName,
  getAreaName,
} = useDeliveryCapSettingTable({
  errdialog,
  errMessage,
  overlay,
  processFlag,
  selectShopFlg,
  selectAreaFlg,
  selectGroupFlg,
  selectGroupIdFlg,
  setIdFlg,
  mode,
  chainViewFlag,
  wordList,
  chainSelectValues,
  shopSelectValues,
  areaSelectValues,
  areaListItems,
  shopListItems,
  shopListInput,
  deliveryGroupSelectValues,
  deliveryGroupIdSelectValues,
  tableHeaders,
  displayDateFrom,
  displayDateTo,
  listDataArray,
  listGroupDataArray,
  deliveryCapOrdersListInput,
  deliveryGroupCapOrdersListInput,
  areaParentData,
  mappedListData,
  mappedListGroupData,
});

// ---- フィルター（共有 refs + Table関数を受け取る） ----
const {
  deliveryGroupListItems,
  deliveryGroupItems,
  onChangeChain,
  onChangeShop,
  onChangeArea,
  onChangeDeliveryGroup,
  onChangeDeliveryGroupId,
  onClickShopTab,
  onClickGroupTab,
} = useDeliveryCapSettingFilter({
  errdialog,
  errMessage,
  processFlag,
  mode,
  selectShopFlg,
  selectAreaFlg,
  selectGroupFlg,
  selectGroupIdFlg,
  setIdFlg,
  chainListItems,
  chainSelectValues,
  shopListItems,
  shopSelectValues,
  areaListItems,
  areaSelectValues,
  deliveryGroupSelectValues,
  deliveryGroupIdSelectValues,
  shopListInput,
  deliveryGroupListInput,
  deliveryGroupGetInput,
  getCapOrders,
  getGroupCapOrders,
  tableHeaders,
  listDataArray,
  listGroupDataArray,
  mappedListData,
  mappedListGroupData,
  areaParentData,
  displayDateFrom,
  displayDateTo,
  deliveryCapOrdersListInput,
  deliveryGroupCapOrdersListInput,
});

// ---- アクション ----
const {
  onClickEdit,
  onClickEditConfirm,
  onClickCancel,
  onClickEditOK,
} = useDeliveryCapSettingActions({
  errdialog,
  errMessage,
  validErrdialog,
  capMessage,
  overlay,
  processFlag,
  confirmDialog,
  completeDialog,
  mode,
  chainSelectValues,
  shopSelectValues,
  deliveryGroupSelectValues,
  mappedListData,
  mappedListGroupData,
  getGroupCapOrders,
});

// ---- ダイアログ ----
const {
  parentGroupItems,
  deliveryTimeConfirm,
  confirmAreaGroup,
  confirmDeliveryGroup,
  toGroupCap,
  confirmDeliveryTime,
  toShopCap,
} = useDeliveryCapSettingDialog({
  overlay,
  model,
  groupConfirmDialog,
  deliveryTimeConfirmDialog,
  selectShopFlg,
  selectAreaFlg,
  selectGroupFlg,
  selectGroupIdFlg,
  setIdFlg,
  chainSelectValues,
  shopSelectValues,
  shopListItems,
  areaListItems,
  areaSelectValues,
  deliveryGroupListItems,
  deliveryGroupSelectValues,
  deliveryGroupItems,
  deliveryGroupIdSelectValues,
  shopListInput,
  deliveryGroupListInput,
  deliveryGroupGetInput,
  displayDateFrom,
  displayDateTo,
  listDataArray,
  listGroupDataArray,
  getCapOrders,
  getGroupCapOrders,
  onClickShopTab,
  onClickGroupTab,
});

////////////////////////////////////////////////////////////////////////////////
// 初期画面
////////////////////////////////////////////////////////////////////////////////
onMounted(async () => {
  await runInitialLoad();
});
</script>

<style scoped>
.compact-form.v-text-field :deep(input) {
  font-size: 0.9em;
  padding: 2px 4px 2px 0 !important;
  line-height: 20px !important;
  height: 22px !important;
  width: 36px !important;
}
.compact-form :deep(.v-field__input) {
  min-height: 22px !important;
  padding-top: 1px !important;
  padding-bottom: 1px !important;
}
.cap-cell-content {
  width: 100%;
  height: 100%;
  align-items: center;
}
.blank-line-content {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
}
:deep(.cap-cell-sat) {
  background-color: rgba(227, 242, 253, 0.6) !important;
}
:deep(.cap-cell-sun) {
  background-color: rgba(255, 235, 238, 0.6) !important;
}
:deep(.blank_line) {
  background-color: #f5f5f5 !important;
}
.link-primary {
  color: rgb(var(--v-theme-primary));
  cursor: pointer;
  text-decoration: underline;
}
.cap-group-table :deep(.v-table__wrapper) {
  overflow-y: visible;
}
</style>
